import Special from '@/views/article/Special.vue';
import ExhibitionDetail from '@/views/article/ExhibitionDetail.vue';
import ExhibitionMap from '@/views/article/ExhibitionMap.vue';
import EventDetail from "@/views/article/EventDetail.vue";
import NewsDetail from "@/views/article/NewsDetail.vue";
import SpecialDetail from "@/views/article/SpecialDetail.vue";
import Article from "@/views/article/Article.vue";

export const articleRoutes = [

    {
        path: '/article',
        name: 'Article',
        redirect: '/article/special',
        children: [
            {
                path: '/article/special',
                name: 'Special',
                component: Special,
                props: true,
                meta: {
                    analytics: {
                        category: 'special',
                        type: 'list'
                    },
                    keepScrollPosition: true
                }
            },
            {
                path: '/article/special/:uuid',
                name: 'SpecialDetail',
                component: SpecialDetail,
                props: true,
                meta: {
                    analytics: {
                        category: 'special',
                        type: 'detail'
                    }
                }
            },
            {
                path: '/article/special/share/:uuid/:subTitle',
                name: 'SpecialDetailCode',
                component: SpecialDetail,
                props: true,
                meta: {
                    analytics: {
                        category: 'special',
                        type: 'share'
                    }
                }
            },
            {
                path: '/article/exhibition',
                name: 'Exhibition',
                component: Article,
                props: true,
                meta: {
                    analytics: {
                        category: 'exhibition',
                        type: 'list'
                    },
                    keepScrollPosition: true
                }
            },
            {
                // ':uuid' 보다 먼저 둔다 — 나중이면 'map' 이 uuid 로 잡혀 상세로 빠진다.
                path: '/article/exhibition/map',
                name: 'ExhibitionMap',
                component: ExhibitionMap,
                props: true,
                meta: {
                    analytics: {
                        category: 'exhibition',
                        type: 'map'
                    }
                }
            },
            {
                path: '/article/exhibition/:uuid',
                name: 'ExhibitionDetail',
                component: ExhibitionDetail,
                props: true,
                meta: {
                    analytics: {
                        category: 'exhibition',
                        type: 'detail'
                    }
                }
            },
            {
                path: '/article/event',
                name: 'Event',
                component: Article,
                props: true,
                meta: {
                    analytics: {
                        category: 'event',
                        type: 'list'
                    },
                    keepScrollPosition: true
                }
            },
            {
                path: '/article/event/:uuid',
                name: 'EventDetail',
                component: EventDetail,
                props: true,
                meta: {
                    analytics: {
                        category: 'event',
                        type: 'detail'
                    }
                }
            },
            {
                path: '/article/news',
                name: 'News',
                component: Article,
                props: true,
                meta: {
                    analytics: {
                        category: 'news',
                        type: 'list'
                    },
                    keepScrollPosition: true
                }
            },
            {
                path: '/article/news/:uuid',
                name: 'NewsDetail',
                component: NewsDetail,
                props: true,
                meta: {
                    analytics: {
                        category: 'news',
                        type: 'detail'
                    }
                }
            },
            {
                path: '/article/news/:uuid/contest-preview',
                name: 'InternalNewsDetail',
                component: NewsDetail,
                props: true,
                meta: {
                    analytics: {
                        category: 'news',
                        type: 'contest_preview'
                    }
                }
            }
        ]
    },

];